export const intervalPeriods = {
  MONTH: "month",
  YEAR: "year"
}

export const paywallSourceTypes = {
  ARTICLE: "article",
  ASSET: "asset",
  CUSTOM_NAVIGATION: "custom_navigation",
  EVENT_BUTTON: "event_button",
  FOLDER: "folder",
  LINK_BUTTON: "link_button",
  LIVESTREAM: "livestream",
  NOTIFICATION: "notification",
  NUDGE_BANNER: "paywall_nudge_banner",
  POST: "post",
  PUSH_NOTIFICATION: "push_notification",
  STARTUP: "startup"
}
